import React, { useState, useRef, useEffect } from "react";
import {
  DropdownInput,
  DropdownItem,
  DropdownList,
  SearchableDropdownWrapper,
} from "./styles";

interface SearchableDropdownProps {
  options: Array<{ id: number; pubName: string }>;
  selectedValue?: number;
  onSelect: (value: number) => void;
  placeholder?: string;
}

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({
  options,
  selectedValue,
  onSelect,
  placeholder = "펍을 검색하세요...",
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // 선택된 옵션의 이름 표시
  const selectedOption = options.find((option) => option.id === selectedValue);
  const displayValue = selectedOption ? selectedOption.pubName : "";

  useEffect(() => {
    const filtered = options.filter((option) =>
      option.pubName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchTerm, options]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputClick = () => {
    setIsOpen(true);
    setSearchTerm("");
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setIsOpen(true);
  };

  const handleOptionClick = (option: { id: number; pubName: string }) => {
    onSelect(option.id);
    setIsOpen(false);
    setSearchTerm("");
  };

  return (
    <SearchableDropdownWrapper ref={dropdownRef}>
      <DropdownInput
        type="text"
        value={isOpen ? searchTerm : displayValue}
        onChange={handleInputChange}
        onClick={handleInputClick}
        placeholder={placeholder}
        autoComplete="off"
      />
      {isOpen && (
        <DropdownList>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <DropdownItem
                key={option.id}
                onClick={() => handleOptionClick(option)}
                $isSelected={option.id === selectedValue}
              >
                {option.pubName}
              </DropdownItem>
            ))
          ) : (
            <DropdownItem $isSelected={false}>
              검색 결과가 없습니다.
            </DropdownItem>
          )}
        </DropdownList>
      )}
    </SearchableDropdownWrapper>
  );
};

export default SearchableDropdown;
